import axios from "./axios";
import { toast } from "sonner";

export const saveCartToLocal = (cartItems) => {
  try {
    // Ensure we're saving an array
    const itemsToSave = Array.isArray(cartItems) ? cartItems : [];
    localStorage.setItem("guest_cart", JSON.stringify(itemsToSave));
  } catch (error) {
    console.error('Error saving cart to localStorage:', error);
    // If localStorage is full or unavailable, try to clear old data and retry
    try {
      localStorage.removeItem("guest_cart");
      if (Array.isArray(cartItems)) {
        localStorage.setItem("guest_cart", JSON.stringify(cartItems));
      }
    } catch (retryError) {
      console.error('Failed to save cart even after clearing:', retryError);
    }
  }
};

export const getCartFromLocal = () => {
  try {
    const cart = localStorage.getItem("guest_cart");
    if (!cart) {
      return [];
    }
    const parsed = JSON.parse(cart);
    // Ensure we return an array
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error('Error reading cart from localStorage:', error);
    // If localStorage is corrupted, clear it and return empty array
    localStorage.removeItem("guest_cart");
    return [];
  }
};

export const clearGuestCart = () => {
  localStorage.removeItem("guest_cart");
};

export const addToCart = async (product, quantity = 1, user) => {
  const cart = getCartFromLocal() || [];

  // ✅ Calculate final price (discount as flat amount)
  const hasDiscount = product.discount > 0;
  const finalPrice = hasDiscount
    ? product.price - product.discount
    : product.price;

  // make sure we always store BOTH id and productId
  const existingItem = cart.find(
    (item) => item.productId === product.productId
  );

  if (existingItem) {
    existingItem.quantity += quantity;
    // ✅ Update stock_quantity if provided (to keep it current)
    if (product.stock_quantity !== undefined) {
      existingItem.stock_quantity = product.stock_quantity;
    }
  } else {
    cart.push({
      id: product.id,
      productId: product.productId,
      name: product.name,
      price: finalPrice, // ✅ store discounted price
      originalPrice: product.price, // ✅ keep original for reference
      discount: product.discount || 0, // ✅ store discount amount
      image: product.image,
      quantity,
      stock_quantity: product.stock_quantity, // ✅ store stock quantity (undefined if not provided)
    });
  }

  saveCartToLocal(cart);

  // 🔹 Notify listeners
  window.dispatchEvent(new Event("cartUpdated"));

  // Show toast
  toast.success(`${product.name} has been added to your cart!`);

  if (user) {
    try {
      await axios.post("/auth/cart/sync", {
        items: cart.map((item) => ({
          productId: item.productId,
          quantity: item.quantity,
          ...(item.variationId && { variationId: item.variationId }),
        })),
      });
    } catch (err) {
      console.error("Failed to add to cart:", err);
      toast.error("Failed to sync cart with server.");
    }
  }
};
